const safetyItems = [
  {
    icon: 'ri-user-search-line',
    title: 'Weryfikacja sprzedawców',
    desc: 'Każdy sprzedawca w arkuszu przechodzi proces weryfikacji. Sprawdzamy historię transakcji, opinie kupujących i jakość produktów, zanim trafią do naszego spreadsheet.',
  },
  {
    icon: 'ri-camera-line',
    title: 'Zdjęcia QC',
    desc: 'Zanim produkt trafi do Ciebie, otrzymujesz zdjęcia kontrolne jakości wykonane w magazynie Kakobuy. Widzisz dokładnie to, co kupujesz.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Bezpieczne płatności',
    desc: 'Wszystkie transakcje są szyfrowane i chronione. Kakobuy obsługuje karty kredytowe, PayPal i inne bezpieczne metody płatności.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Ochrona wysyłki',
    desc: 'Twoja paczka jest ubezpieczona na czas transportu. W przypadku zaginięcia lub uszkodzenia przesyłki otrzymujesz pełny zwrot kosztów.',
  },
  {
    icon: 'ri-refund-2-line',
    title: 'Polityka zwrotów',
    desc: 'Jeśli produkt nie spełnia Twoich oczekiwań, możesz skorzystać z polityki zwrotów. Kakobuy pomaga w całym procesie reklamacyjnym.',
  },
];

export default function SafetyCenter() {
  return (
    <section id="safety" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line"></i>
            </div>
            Kakobuy Bezpieczeństwo
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Twoje bezpieczeństwo jest dla nas priorytetem
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Kakobuy oferuje kompleksową ochronę na każdym etapie zakupów — od wyboru sprzedawcy po dostarczenie paczki.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {safetyItems.map((item, i) => (
            <div
              key={item.title}
              className="bg-white rounded-xl p-5 border border-background-200/70 hover:border-accent-200 transition-all duration-300 animate-[fadeInUp_0.5s_ease-out]"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                <i className={`${item.icon} text-accent-500 text-base`}></i>
              </div>
              <h3 className="font-semibold text-sm text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}